
import LogoWhite from '../../assets/images/logoWhite.png'
import Logo from '../../assets/images/skysalepklogo.png'
import { useEffect, useLayoutEffect, useState } from "react"
import { createPortal } from "react-dom"
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { PhoneCall, Phone, Mail, X, Home, PlaneTakeoff, Gift, MessageSquare, Landmark, User } from 'lucide-react'
import { appConfig } from '../../appConfig'
import Bars from '../../assets/images/bars.svg'
import Service from '../../Service/Service'
import ContactForm from '../Contact/ContactForm'
import { trackEvent } from '../../utils/analytics'
import {
    CONTACT_CHANGED_EVENT,
    getSavedFlightSearchContact,
} from '../../utils/flightSearchDetails'

const PHONE_NUMBER = '03338820922'
const PHONE_DISPLAY = '0333 8820922'
const CONTACT_EMAIL = 'support@skysale.pk'

const MOBILE_NAV_LINKS = [
    { label: 'Home', href: '/', icon: Home },
    { label: 'Flights', href: '/', icon: PlaneTakeoff },
    { label: 'Packages', href: '/packages', icon: Gift },
    { label: 'Umrah Packages', href: '/allpackages?category=0&type=umrah', icon: Landmark },
    { label: 'Contact', href: '/contact', icon: MessageSquare },
]



const NAVBAR_PORTAL_ID = 'navbar-fixed-portal'

const Navbar = props => {

    const headRoute = appConfig.headRoute

    const [viewMenu, setViewMenu] = useState(false)
    const [categories, setCategories] = useState([])
    const [tabindex, setTabIndex] = useState(1)
    const [portalEl, setPortalEl] = useState(null)
    const [guestContact, setGuestContact] = useState(() => getSavedFlightSearchContact())

    const navigate = useNavigate()
    const location = useLocation()

    const getCategories = () => {

        Service.getAllCategory().then(response => {

            setCategories(response.data)
        })
    }

    useEffect(() => {
        const syncGuest = () => setGuestContact(getSavedFlightSearchContact())
        syncGuest()
        window.addEventListener(CONTACT_CHANGED_EVENT, syncGuest)
        window.addEventListener('storage', syncGuest)
        return () => {
            window.removeEventListener(CONTACT_CHANGED_EVENT, syncGuest)
            window.removeEventListener('storage', syncGuest)
        }
    }, [])
    useEffect(() => {
        getCategories();
    }, [])

    // Create a dedicated fixed container as first child of body so header never scrolls
    useLayoutEffect(() => {
        let el = document.getElementById(NAVBAR_PORTAL_ID)
        if (!el) {
            el = document.createElement('div')
            el.id = NAVBAR_PORTAL_ID
            el.style.setProperty('position', 'fixed', 'important')
            el.style.setProperty('top', '0', 'important')
            el.style.setProperty('left', '0', 'important')
            el.style.setProperty('right', '0', 'important')
            el.style.setProperty('z-index', '9999', 'important')
            document.body.insertBefore(el, document.body.firstChild)
        }
        setPortalEl(el)
    }, [])

    // Prevent background scrolling when mobile menu is open
    useEffect(() => {
        if (viewMenu) {
            const prevBodyOverflow = document.body.style.overflow;
            const prevHtmlOverflow = document.documentElement.style.overflow;

            document.body.style.overflow = 'hidden';
            document.documentElement.style.overflow = 'hidden';

            return () => {
                document.body.style.overflow = prevBodyOverflow || '';
                document.documentElement.style.overflow = prevHtmlOverflow || '';
            };
        } else {
            document.body.style.overflow = '';
            document.documentElement.style.overflow = '';
        }
    }, [viewMenu])

    const url = window.location.pathname
    const isHomePage = url === '/' || url === (headRoute || '') || url === `${headRoute || ''}/`
    const isFlightSearchPage = url.includes('flight-detail-search')
    console.log(' %% URL : ', url)

    // Determine background color
    let bgClass = 'bg-transparent';
    if (props.bg === 'blue') {
        bgClass = 'bg-secondary';
    } else if (props.bg) {
        bgClass = 'bg-secondary';
    }
    // On flight search page use red header on desktop too
    if (isFlightSearchPage && props.bg) {
        bgClass = 'bg-secondary';
    }
    const solidBgOnDesktop = isFlightSearchPage;

    const navbarEl = (
        <div data-navbar-root className={`${bgClass} ${solidBgOnDesktop ? '' : 'md:bg-transparent'} fixed top-0 left-0 right-0 w-full z-50 h-14 min-h-14`}>
            <DialogueContactUs />
            {/* Desktop: on home page hide header bar (logo/links are in banner); on other pages show it */}
            <div className={isHomePage ? 'md:hidden' : ''}>
            {/* <div className='navTopSection h-[40px] items-center px-14 border-b border-b-white hidden lg-1:flex'>
                         <div className='flex gap-8 text-xs font-normal text-white'>
                             <p>
                                 support@skysale.pk
                             </p>
                             <p>
                                 073-082-327-84
                             </p>
                             <p>
                             32 IT tower, Link road model town, Lahore
                             </p>
                         </div>
                     </div> */}

            <div className="navbar w-full md:w-[85%] mx-auto md:bg-transparent">

                <div className="navbar-start ml-0 px-0  w-full lg-1:w-1/5">
                    <Link
                        className="btn btn-ghost normal-case text-xl p-0 md:px-1"
                    >
                        {/* {
                        url=='/'? */}
                        {/* <div className='logo'>
                            
                            <img src={LogoDark} className='w-[200px]'/>
                            
                        </div> */}
                        <div className='logo -mt-1.5 ml-1 flex items-center' role='button' onClick={() => { navigate(`/`) }}>
                            <img src={Logo} className='w-[140px] hidden lg-1:block' alt="SKYSALE PK" />
                            <img src={Logo} className='h-[44px] w-auto max-w-[200px] object-contain block lg-1:hidden' alt="SKYSALE PK" />
                        </div>

                    </Link>
                </div>
                <div className="navbar-center hidden gap-3 lg-1:flex">

                    {/* <div className="dropdown dropdown-hover ">
                    <label tabIndex={0} className="cursor-pointer m-1 text-white tracking-[1px] leading-7">Pages</label>
                    <ul tabIndex={0} className="dropdown-content z-[1] menu p-2 shadow bg-black text-white w-52">
                        <li >
                            <Link className='bg-transparent font-poppins tracking-[2px]' to={'/about'}>
                                ABOUT US 
                            </Link>
                        </li>
                        <li >
                            <Link 
                        className='bg-transparent font-poppins tracking-[2px]'
                        to={`${headRoute}/contact`}
                        >
                            CONTACT US
                        </Link>
                    </li>
                    </ul>
                </div> */}
                    <Link className='bg-transparent font-poppins tracking-[2px]' role='button' onClick={() => { navigate('/') }}>
                        <label className="cursor-pointer m-1 text-white tracking-[1px] leading-7">Fights</label>
                    </Link>
                    <Link className='bg-transparent font-poppins tracking-[2px]' role='button' onClick={() => { navigate('/packages') }}>
                        <label className="cursor-pointer m-1 text-white tracking-[1px] leading-7">Packages</label>
                    </Link>
                    <Link className='bg-transparent font-poppins tracking-[2px]' role='button' onClick={() => { navigate(`/allpackages?category=0&type=umrah`) }}>
                        <label className="cursor-pointer m-1 text-white tracking-[1px] leading-7">Umrah Packages</label>
                    </Link>

                    {/* <div className="dropdown dropdown-hover">
  <label tabIndex={0} className="cursor-pointer m-1 text-white tracking-[1px] leading-7">Holidays</label>
  <ul tabIndex={0} className="dropdown-content z-[1] menu p-2 shadow bg-primary rounded-box w-52">
  {
                                    categories.map(x=>{
                                        return <Link className='bg-transparent font-poppins tracking-[2px]' to={`/allpackages?category=${x.uid}&type=holiday`}>
                                        <li className='p-2'>{x.name}</li>
                                    </Link>
                                        

                                    })
                                }
    
    
  </ul>
</div> */}



                    {/* <div className="dropdown dropdown-hover">
  <label tabIndex={0} className="cursor-pointer m-1 text-white tracking-[1px] leading-7">Umrah Packages</label>
  <ul tabIndex={0} className="dropdown-content z-[1] menu p-2 shadow bg-primary rounded-box w-52">
  {
                                    categories.map(x=>{
                                        return <Link className='bg-transparent font-poppins tracking-[2px]' to={`/allpackages?category=${x.uid}&type=umrah`}>
                                        <li className='p-2'>{x.name}</li>
                                    </Link>
                                        

                                    })
                                }
    
    
  </ul>
</div> */}


                    {/* <details>
          <summary tabIndex={0}>Parent</summary>
          <ul className="p-2">
          
          </ul>
        </details>
       */}



                    {/* <Link className='bg-transparent font-poppins tracking-[2px]' role='button' onClick={()=>{ navigate(`/umrahvisa`)}}>
                <label  className="cursor-pointer m-1 text-white tracking-[1px] leading-7">Umrah Visa</label>
                            </Link> */}


                    <Link className='bg-transparent font-poppins tracking-[2px]' role='button' onClick={() => { navigate('/contact') }}>
                        <label className="cursor-pointer m-1 text-white tracking-[1px] leading-7">Contact Us</label>
                    </Link>
                    {/* <Link className='bg-transparent font-poppins tracking-[2px]' to={'/aboutus'}>
                <label  className="cursor-pointer m-1 text-white tracking-[1px] leading-7">About Us</label>
                            </Link> */}

                </div>





                {/* Phone at far right on desktop; hamburger on mobile */}
                <div className="navbar-end flex items-center gap-2">
                    {guestContact?.phone && (
                        <div
                            className="hidden lg-1:flex items-center gap-2 cursor-default"
                            title={guestContact.phone}
                            aria-label="Guest account"
                        >
                            <div className="bg-white/20 p-1.5 rounded-full">
                                <User className="text-white w-4 h-4" />
                            </div>
                            <div className="flex flex-col leading-tight">
                                <span className="text-[10px] text-white/80 font-medium tracking-wide">Guest</span>
                                <span className="text-sm font-bold text-white tracking-wide max-w-[140px] truncate">
                                    {guestContact.phone}
                                </span>
                            </div>
                        </div>
                    )}
	                    <a
	                        href={`tel:${PHONE_NUMBER}`}
	                        className="hidden lg-1:flex items-center gap-2 cursor-pointer hover:opacity-90"
	                        aria-label="Call us"
	                        onClick={() => trackEvent('phone_click', { source: 'navbar', phone_number: PHONE_NUMBER })}
	                    >
                        <div className="bg-white/20 p-1.5 rounded-full">
                            <PhoneCall className="text-white w-4 h-4" />
                        </div>
                        <div className="flex flex-col leading-tight">
                            <span className="text-[10px] text-white/80 font-medium tracking-wide">Call Us Now</span>
                            <span className="text-sm font-bold text-white tracking-wide">{PHONE_NUMBER}</span>
                        </div>
                    </a>
                    {/* Hamburger button - mobile only */}
                    <button
                        type="button"
                        aria-label="Open navigation menu"
                        className="btn btn-ghost rounded-full p-1 lg-1:hidden"
                        onClick={() => setViewMenu(true)}
                    >
                        <img src={Bars} height="28" width="28" alt="Menu" />
                    </button>

                    {/* Full-screen mobile menu overlay */}
                    {viewMenu && (
                        <div className="fixed inset-0 z-[100] lg-1:hidden">
                            <div
                                className="absolute inset-0 bg-black/60 backdrop-blur-sm"
                                onClick={() => setViewMenu(false)}
                                aria-hidden="true"
                            />

                            <div className="absolute top-0 right-0 h-full w-80 max-w-[85vw] bg-white text-gray-900 shadow-2xl flex flex-col overflow-hidden animate-slide-in-right">
                                <div className="flex items-center justify-between px-5 py-4 bg-secondary border-b border-secondary">
                                    <img
                                        src={Logo}
                                        alt="SKYSALE PK"
                                        className="h-[44px] w-auto max-w-[200px] object-contain cursor-pointer"
                                        role="button"
                                        onClick={() => { setViewMenu(false); navigate('/'); }}
                                    />
                                    <button
                                        type="button"
                                        aria-label="Close navigation menu"
                                        className="w-8 h-8 rounded-full bg-white/15 hover:bg-white/25 flex items-center justify-center transition-colors"
                                        onClick={() => setViewMenu(false)}
                                    >
                                        <X className="w-4 h-4 text-white" />
                                    </button>
                                </div>

                                <nav className="flex flex-col gap-1 px-3 py-4">
                                    {guestContact?.phone && (
                                        <div className="flex items-center gap-3 px-4 py-3 rounded-xl bg-secondary/10 text-secondary mb-1">
                                            <span className="flex items-center justify-center w-7 h-7 rounded-lg bg-secondary/15">
                                                <User className="w-4 h-4 text-secondary" />
                                            </span>
                                            <div className="min-w-0">
                                                <p className="text-sm font-semibold">Guest</p>
                                                <p className="text-xs text-gray-500 truncate">{guestContact.phone}</p>
                                            </div>
                                        </div>
                                    )}
                                    {MOBILE_NAV_LINKS.map((link) => {
                                        const active = location.pathname === link.href
                                            || (link.href.includes('?') && `${location.pathname}${location.search}` === link.href);
                                        const Icon = link.icon;
                                        return (
                                            <button
                                                key={link.href + link.label}
                                                type="button"
                                                className={`flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-semibold transition-all w-full text-left ${
                                                    active
                                                        ? 'bg-secondary text-white shadow-lg shadow-blue-900/20'
                                                        : 'text-gray-700 hover:bg-gray-100 hover:text-gray-900'
                                                }`}
                                                onClick={() => {
                                                    setViewMenu(false);
                                                    navigate(link.href);
                                                }}
                                            >
                                                <span className={`flex items-center justify-center w-7 h-7 rounded-lg ${
                                                    active ? 'bg-white/20' : 'bg-gray-100'
                                                }`}>
                                                    <Icon className={`w-4 h-4 ${active ? 'text-white' : 'text-gray-500'}`} />
                                                </span>
                                                {link.label}
                                            </button>
                                        );
                                    })}
                                </nav>

                                <div className="mx-5 border-t border-gray-100" />

                                <div className="flex flex-col gap-2 px-3 py-4">
                                    <p className="text-[10px] uppercase tracking-widest font-semibold text-gray-400 px-2 mb-1">
                                        Contact us
                                    </p>
                                    <a
                                        href={`tel:${PHONE_NUMBER}`}
                                        className="flex items-center gap-3 px-4 py-3 rounded-xl bg-gray-50 hover:bg-gray-100 transition-colors group"
                                        onClick={() => {
                                            trackEvent('phone_click', { source: 'mobile_nav', phone_number: PHONE_NUMBER });
                                            setViewMenu(false);
                                        }}
                                    >
                                        <span className="w-8 h-8 rounded-lg bg-secondary flex items-center justify-center shrink-0">
                                            <Phone className="w-3.5 h-3.5 text-white" />
                                        </span>
                                        <div>
                                            <p className="text-[10px] text-gray-400 leading-none mb-0.5">Call us</p>
                                            <p className="text-sm font-bold text-gray-900 group-hover:text-secondary transition-colors">
                                                {PHONE_DISPLAY}
                                            </p>
                                        </div>
                                    </a>
                                    <a
                                        href={`mailto:${CONTACT_EMAIL}`}
                                        className="flex items-center gap-3 px-4 py-3 rounded-xl bg-gray-50 hover:bg-gray-100 transition-colors group"
                                        onClick={() => setViewMenu(false)}
                                    >
                                        <span className="w-8 h-8 rounded-lg bg-orange-500 flex items-center justify-center shrink-0">
                                            <Mail className="w-3.5 h-3.5 text-white" />
                                        </span>
                                        <div>
                                            <p className="text-[10px] text-gray-400 leading-none mb-0.5">Email us</p>
                                            <p className="text-sm font-bold text-gray-900 group-hover:text-orange-500 transition-colors break-all">
                                                {CONTACT_EMAIL}
                                            </p>
                                        </div>
                                    </a>
                                </div>

                                <div className="mt-auto px-5 pb-8 pt-4 border-t border-gray-100">
                                    <button
                                        type="button"
                                        className="flex items-center justify-center gap-2 w-full py-3.5 bg-orange-500 hover:bg-orange-400 text-white font-bold rounded-2xl text-sm transition-all shadow-lg shadow-orange-500/30"
                                        onClick={() => {
                                            setViewMenu(false);
                                            navigate('/contact');
                                        }}
                                    >
                                        Get a Free Quote
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            </div>
        </div>
    );
    if (!portalEl) return null
    return createPortal(navbarEl, portalEl)
        // <div className='absolute z-10 top-0 left-0 w-full font-poppins'>

        //     <div 
        //     className={`
        //         nav 
        //         ${
        //             url!='/'?
        //             'bg-white lg-1:bg-transparent':'bg-transparent'
        //         }
        //     `}
        //     >

        //         {
        //             url!='/'?
        //             <div className='navTopSection h-[40px] items-center px-14 border-b border-b-white hidden lg-1:flex'>
        //                 <div className='flex gap-8 text-xs font-normal text-white'>
        //                     <p>
        //                         valiance@qodeinteractive.com
        //                     </p>
        //                     <p>
        //                         073-082-327-84
        //                     </p>
        //                     <p>
        //                         Maria-Theresien-Platz, 1010 Wien
        //                     </p>
        //                 </div>
        //             </div>:''
        //         }
        //         <div className='logoSection py-9 px-14 flex gap-12'>

        //             {
        //                 url=='/'?
        //                 <div className='logo'>

        //                     <img src={LogoDark} className='w-[200px]'/>

        //                 </div>:
        //                 <div className='logo'>
        //                     <img src={LogoWhite} className='w-[200px] hidden lg-1:block'/>
        //                     <img src={LogoDark} className='w-[200px] block lg-1:hidden'/>
        //                 </div>
        //             }
        //             <div>

        //                 <div  className='hidden lg-1:flex flex-column lg-1:flex-row gap-11'>
        //                     <div className="dropdown dropdown-hover">
        //                         <label tabIndex={0} className="cursor-pointer m-1">Home</label>
        //                         <ul tabIndex={0} className="dropdown-content z-[1] menu p-2 shadow bg-black text-white w-52">
        //                             <li >
        //                                 <Link className='font-poppins tracking-[2px]'>
        //                                     MAIN HOME
        //                                 </Link>
        //                             </li>
        //                             <li >
        //                                 <Link className='font-poppins tracking-[2px]'>
        //                                     CONSULTING HOME
        //                                 </Link>
        //                             </li>
        //                         </ul>
        //                     </div>

        //                     <div className="dropdown dropdown-hover">
        //                         <label tabIndex={0} className="cursor-pointer m-1">Pages</label>
        //                         <ul tabIndex={0} className="dropdown-content z-[1] menu p-2 shadow bg-black text-white w-52">
        //                             <li >
        //                                 <Link className='bg-transparent font-poppins tracking-[2px]'>
        //                                     ABOUT US 
        //                                 </Link>
        //                             </li>
        //                             <li >
        //                                 <Link 
        //                                 className='bg-transparent font-poppins tracking-[2px]'
        //                                 to={`${headRoute}/contact`}
        //                                 >
        //                                     CONTACT US
        //                                 </Link>
        //                             </li>
        //                         </ul>
        //                     </div>

        //                 </div>


        //             </div>

        //         </div>
        //     </div>

        // </div>
}

const DialogueContactUs = () => {
    return (
        <dialog id="my_modal_contact" className="modal backdrop-blur-sm">
            <div className="modal-box w-11/12 max-w-4xl max-h-[90vh] bg-white rounded-2xl shadow-2xl p-0 overflow-hidden flex flex-col">
                <form method="dialog">
                    {/* if there is a button in form, it will close the modal */}
                    <button className="btn btn-sm btn-circle btn-ghost absolute right-4 top-4 text-gray-600 hover:bg-gray-100 z-10">✕</button>
                </form>
                <div className="flex-1 overflow-y-auto">
                    <ContactForm />
                </div>
            </div>
            <form method="dialog" className="modal-backdrop">
                <button>close</button>
            </form>
        </dialog>
    )
}
export default Navbar
